import {importSoftcropLinks, exportSoftcropLinks} from './softCrops'

const ImageToolsPackage = {
    name: 'image-tools',
    configure: function(config) {
        config.addPluginModule('se.infomaker.image-tools.softcrop', {importSoftcropLinks, exportSoftcropLinks})
    }
}

export {ImageToolsPackage}
